var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriorityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.96667 2.60003C2.96667 3.28118 2.41448 3.83337 1.73333 3.83337C1.05218 3.83337 0.5 3.28118 0.5 2.60003C0.5 1.91888 1.05218 1.3667 1.73333 1.3667C2.41448 1.3667 2.96667 1.91888 2.96667 2.60003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96667 6.93333C2.96667 7.61448 2.41448 8.16666 1.73333 8.16666C1.05218 8.16666 0.5 7.61448 0.5 6.93333C0.5 6.25218 1.05218 5.7 1.73333 5.7C2.41448 5.7 2.96667 6.25218 2.96667 6.93333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96667 11.2666C2.96667 11.9478 2.41448 12.5 1.73333 12.5C1.05218 12.5 0.5 11.9478 0.5 11.2666C0.5 10.5855 1.05218 10.0333 1.73333 10.0333C2.41448 10.0333 2.96667 10.5855 2.96667 11.2666Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 2.60007H13.0001",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 6.93336H9.1001",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6001 11.2667H6.06676",
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon);
export default __webpack_public_path__ + "static/media/priority_icon.2e9ca83d.svg";
export { ForwardRef as ReactComponent };